module.exports = __webpack_public_path__ + "static/media/designPatent_30-0992954.d25399e5.png";